var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',{staticClass:"res1 res"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('reservation.res1.title')))]),_c('div',{staticClass:"content"},[_c('date-picker',{on:{"picked":_vm.onPicked,"reset":_vm.onReset}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }